
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M22.441 43.939H17.8a4.257 4.257 0 01-4.251-4.254v-9.299h-9.3A4.259 4.259 0 010 26.135v-8.334a4.258 4.258 0 014.254-4.25h9.3v-9.3A4.255 4.255 0 0117.8.001h8.334a4.255 4.255 0 014.255 4.25v9.3h9.301a4.256 4.256 0 014.25 4.25v4.64a15.211 15.211 0 00-4.455-2.775v-1.66H25.934V4.452h-7.927v13.555H4.454v7.927h13.553v13.551h1.66a15.149 15.149 0 002.773 4.453l.001.001z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M34.805 21.609c-7.288 0-13.196 5.908-13.196 13.196 0 7.287 5.908 13.194 13.196 13.194 7.287 0 13.194-5.907 13.194-13.194 0-7.288-5.907-13.196-13.194-13.196zm0 24.39c-6.184 0-11.196-5.013-11.196-11.194 0-6.184 5.012-11.196 11.196-11.196 6.182 0 11.194 5.012 11.194 11.196 0 6.181-5.013 11.194-11.194 11.194z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M37.018 34.266a16.413 16.413 0 00-1.857-.844 4.364 4.364 0 01-1.014-.57.888.888 0 01.233-1.582c.199-.087.416-.131.633-.127a4.845 4.845 0 012.364.463c.38.19.485.127.612-.252.127-.4.253-.823.359-1.246a.425.425 0 00-.275-.57 6.246 6.246 0 00-1.478-.442c-.675-.106-.675-.106-.675-.781 0-.95 0-.95-.971-.95h-.422c-.443.021-.528.084-.528.549v.612c0 .591 0 .591-.569.8a3.22 3.22 0 00-2.344 2.955 3.02 3.02 0 001.71 2.892c.698.367 1.417.691 2.153.971.278.122.541.277.781.465a1.068 1.068 0 01-.254 1.879 2.783 2.783 0 01-1.371.189 5.564 5.564 0 01-2.09-.633c-.381-.211-.508-.148-.634.273-.106.359-.211.719-.317 1.101-.127.486-.084.612.381.845a6.588 6.588 0 001.9.549c.506.084.527.105.527.633v.718a.428.428 0 00.464.485h1.056a.407.407 0 00.442-.463c0-.338.021-.654 0-.992a.51.51 0 01.419-.588l.023-.004a3.607 3.607 0 001.858-1.182 3.43 3.43 0 00-1.116-5.153z"}})])
          )
        }
      }
    